/* ===========================================================
   MT - Interacciones propias de la tienda
   Todo vanilla, sin librerias externas.
   =========================================================== */

(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Animaciones de entrada al hacer scroll --- */
  function initReveal() {
    var elementos = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!elementos.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        entrada.target.classList.add('mt-visible');
        observador.unobserve(entrada.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    elementos.forEach(function (el) { observador.observe(el); });
  }

  /* --- Cifras que cuentan hacia arriba --- */
  function initCifras() {
    var cifras = document.querySelectorAll('[data-mt-contador]:not([data-mt-listo])');
    if (!cifras.length) return;

    function animar(el) {
      el.setAttribute('data-mt-listo', '1');
      var destino = parseFloat(el.getAttribute('data-mt-contador')) || 0;
      var decimales = (el.getAttribute('data-mt-decimales') | 0);
      if (reduce) { el.textContent = destino.toFixed(decimales); return; }
      var duracion = 1400;
      var inicio = null;
      function paso(t) {
        if (inicio === null) inicio = t;
        var p = Math.min((t - inicio) / duracion, 1);
        var suave = 1 - Math.pow(1 - p, 3);
        el.textContent = (destino * suave).toFixed(decimales);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) {
      cifras.forEach(animar);
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        animar(e.target);
        obs.unobserve(e.target);
      });
    }, { threshold: 0.5 });
    cifras.forEach(function (el) { obs.observe(el); });
  }

  /* --- Carrusel infinito de resenas: duplica el contenido --- */
  function initMarquesinas() {
    var pistas = document.querySelectorAll('[data-mt-marquesina]:not([data-mt-listo])');
    pistas.forEach(function (pista) {
      pista.setAttribute('data-mt-listo', '1');
      var original = pista.innerHTML;
      pista.innerHTML = original + original;
    });
  }

  /* --- Videos dentro de las resenas: paran el carrusel mientras se ven --- */
  function initResenaVideos() {
    var videos = document.querySelectorAll('.mt-resena__media video:not([data-mt-listo])');
    videos.forEach(function (video) {
      video.setAttribute('data-mt-listo', '1');
      var pista = video.closest('.mt-resenas__pista');
      if (!pista) return;

      video.addEventListener('play', function () { pista.classList.add('mt-pausada'); });
      ['pause', 'ended'].forEach(function (evento) {
        video.addEventListener(evento, function () {
          /* Solo reanuda si no queda ningun otro video en marcha */
          var alguno = Array.prototype.some.call(pista.querySelectorAll('video'), function (v) {
            return !v.paused && !v.ended;
          });
          if (!alguno) pista.classList.remove('mt-pausada');
        });
      });
    });
  }

  /* --- Galeria de la pagina de producto --- */
  function initGaleria() {
    var galerias = document.querySelectorAll('[data-mt-galeria]:not([data-mt-listo])');
    galerias.forEach(function (galeria) {
      galeria.setAttribute('data-mt-listo', '1');
      var principal = galeria.querySelector('[data-mt-galeria-principal]');
      var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
      if (!principal || !minis.length) return;

      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-src');
          if (!src) return;
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = src;
            principal.alt = mini.getAttribute('data-alt') || '';
            principal.style.opacity = '1';
          }, 160);
          minis.forEach(function (m) { m.classList.remove('mt-activa'); });
          mini.classList.add('mt-activa');
        });
      });
    });
  }

  /* --- Selector de variantes + cantidad de la pagina de producto --- */
  function initCompra() {
    var bloques = document.querySelectorAll('[data-mt-compra]:not([data-mt-listo])');
    bloques.forEach(function (bloque) {
      bloque.setAttribute('data-mt-listo', '1');

      /* Cantidad */
      var stepper = bloque.querySelector('[data-mt-stepper]');
      if (stepper) {
        var campo = stepper.querySelector('input');
        stepper.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function (ev) {
            ev.preventDefault();
            var delta = b.getAttribute('data-mt-paso') === 'mas' ? 1 : -1;
            var v = parseInt(campo.value, 10) || 1;
            campo.value = Math.max(1, v + delta);
          });
        });
      }

      /* Variantes */
      var datos = bloque.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      if (!variantes || variantes.length < 2) return;

      var grupos = bloque.querySelectorAll('[data-mt-opcion]');
      if (!grupos.length) return;

      var campoId = bloque.querySelector('[data-mt-variante-id]');
      var precio = bloque.querySelector('[data-mt-precio]');
      var precioAntes = bloque.querySelector('[data-mt-precio-antes]');
      var boton = bloque.querySelector('[data-mt-boton]');
      var textoDisponible = boton ? boton.getAttribute('data-mt-texto') : '';
      var textoAgotado = boton ? boton.getAttribute('data-mt-texto-agotado') : '';

      function seleccion() {
        return Array.prototype.map.call(grupos, function (g) {
          var activa = g.querySelector('.mt-activa');
          return activa ? activa.getAttribute('data-valor') : null;
        });
      }

      function actualizar() {
        var sel = seleccion();
        var v = variantes.find(function (variante) {
          return variante.options.every(function (o, i) { return o === sel[i]; });
        });
        if (!v) return;
        if (campoId) campoId.value = v.id;
        if (precio) precio.innerHTML = v.price;
        if (precioAntes) {
          precioAntes.innerHTML = v.compare_at_price || '';
          precioAntes.style.display = v.compare_at_price ? '' : 'none';
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.textContent = v.available ? textoDisponible : textoAgotado;
        }
      }

      grupos.forEach(function (g) {
        g.querySelectorAll('[data-valor]').forEach(function (btn) {
          btn.addEventListener('click', function (ev) {
            ev.preventDefault();
            g.querySelectorAll('[data-valor]').forEach(function (b) { b.classList.remove('mt-activa'); });
            btn.classList.add('mt-activa');
            actualizar();
          });
        });
      });
    });
  }

  /* --- Video de YouTube o Vimeo: no se carga hasta que le dan al play --- */
  function initVideo() {
    var bloques = document.querySelectorAll('[data-mt-video]:not([data-mt-listo])');
    bloques.forEach(function (bloque) {
      bloque.setAttribute('data-mt-listo', '1');
      var boton = bloque.querySelector('.mt-video__play');
      if (!boton) return;

      boton.addEventListener('click', function () {
        var tipo = bloque.getAttribute('data-tipo');
        var id = bloque.getAttribute('data-id');
        if (!id) return;

        var src = tipo === 'vimeo'
          ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&title=0&byline=0'
          : 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';

        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', src);
        iframe.setAttribute('title', boton.getAttribute('aria-label') || 'Video');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        bloque.innerHTML = '';
        bloque.appendChild(iframe);
      });
    });
  }

  function arrancar() {
    initReveal();
    initCifras();
    initMarquesinas();
    initResenaVideos();
    initGaleria();
    initCompra();
    initVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar, { once: true });
  } else {
    arrancar();
  }

  /* En el editor de Shopify, al recargar una seccion hay que reenganchar todo */
  document.addEventListener('shopify:section:load', arrancar);
  document.addEventListener('shopify:section:select', arrancar);
})();
